import { useCallback } from 'react';
import { useSwapActions } from '../internal/useSwapActions';
/**
 * Returns a function to update a persisted swap's data by hashlock.
 */
export function useUpdateSwap() {
    const { updateSwap } = useSwapActions();
    return useCallback((hashlock, updates) => {
        updateSwap(hashlock, updates);
    }, [updateSwap]);
}
